var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299,
    height: 221,
    viewBox: "0 0 299 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M91.636 32H103a8 8 0 0 1 8 8v13.29a8 8 0 0 1-8 8H91.636V32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M91.636 90H103a8 8 0 0 1 8 8v13.29a8 8 0 0 1-8 8H91.636V90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M4 0h86a3 3 0 0 1 3 3v116a3 3 0 0 1-3 3H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-40h300v300H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M264.255 111.742C263.59 172.197 214.41 221 153.842 221 92.86 221 43.423 171.527 43.423 110.5c0-5.053.34-10.026.995-14.899H9.933C4.447 95.601 0 91.154 0 85.67c0-5.486 4.447-9.933 9.933-9.933h78.146c5.486 0 9.933-4.447 9.933-9.933a9.936 9.936 0 0 0-6.468-9.311 9.912 9.912 0 0 1-3.464.62H42.19c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933H71.17C91.401 14.401 120.941 0 153.842 0 201.3 0 241.763 29.96 257.38 72.011h31.688c5.486 0 9.933 4.447 9.933 9.933 0 5.485-4.447 9.932-9.933 9.932h-48.371c-5.486 0-9.933 4.447-9.933 9.933s4.447 9.933 9.933 9.933h23.559z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    d: "M194.636 70H206a8 8 0 0 1 8 8v13.29a8 8 0 0 1-8 8h-11.364V70z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103 67)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M92.136 32.5v28.29H103a7.5 7.5 0 0 0 7.5-7.5V40a7.5 7.5 0 0 0-7.5-7.5H92.136z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#87D5FA",
    d: "M194.636 128H206a8 8 0 0 1 8 8v13.29a8 8 0 0 1-8 8h-11.364V128z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103 67)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M92.136 90.5v28.29H103a7.5 7.5 0 0 0 7.5-7.5V98a7.5 7.5 0 0 0-7.5-7.5H92.136z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103 67)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M4 .5A3.5 3.5 0 0 0 .5 4v114a3.5 3.5 0 0 0 3.5 3.5h86a2.5 2.5 0 0 0 2.5-2.5V3A2.5 2.5 0 0 0 90 .5H4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#87D5FA",
    d: "M160.212 120.136a25.718 25.718 0 0 1-10.712 2.336c-3.924 0-7.636-.886-10.712-2.336-7.955 1.53-13.788 6.928-13.788 13.372V142h49v-8.492c0-6.524-5.94-11.841-13.788-13.372zM148.872 116.455c8.364 0 15.077-6.658 15.077-14.728S157.133 87 148.872 87c-8.262 0-15.077 6.758-15.077 14.828s6.712 14.627 15.077 14.627z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M122.5 153.5h54.083M132.5 166.5h34"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EB8181",
    transform: "translate(184 149)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    d: "M204 161.222v15.802"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M196.222 170.111l7.727 6.81 7.343-6.81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportCustomers);
export default __webpack_public_path__ + "static/media/import-customers.efb3b149612da32f73f8c45fbb7a0266.svg";
export { ForwardRef as ReactComponent };